import classes from "../homePageNew.module.css";
import MonitoringLlmLogo from "./MonitoringLlmLogo";

/**
 * Segmented LLM switcher for the Monitoring chart + Key Insights card.
 * Tabs (with each provider's logo) rather than a dropdown: there are only
 * a handful of providers, all visible at once, so the user can see what's
 * selected and flip between them in one click — and because it sits in the
 * header of the single card that holds both the chart and the insights, it
 * reads as controlling both.
 */
export default function MonitoringLlmTabs({ providerLlms, activeProvider, onChange }) {
  return (
    <div className={classes.monLlmTabs} role="tablist" aria-label="LLM for chart and key insights">
      {providerLlms.map((p) => {
        const active = p.provider === activeProvider;
        return (
          <button
            key={p.provider}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${classes.monLlmTab} ${active ? classes.monLlmTabActive : ""}`}
            onClick={() => onChange(p.provider)}
          >
            <MonitoringLlmLogo domain={p.domain} provider={p.provider} name={p.label} />
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
